var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 816,
    height: 423,
    viewBox: "0 0 816 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 481.348H218.104C321.909 480.502 402.556 413.621 402.556 267.616V220.001C400.694 -7.1012 226.115 -147.182 0.0564159 -148V183.246C0.0564159 223.696 -1.0437 313.257 131.195 313.257H173.31V323.835H73.2279C32.7777 323.835 0 356.612 0 397.062V481.348Z",
    fill: "#F09F9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.999 481.348H597.895C494.09 480.502 413.443 413.621 413.443 267.616V220.001C415.277 -7.1012 589.884 -147.182 815.943 -148V183.246C815.943 223.696 817.043 313.257 684.804 313.257H642.689V323.835H742.771C783.222 323.835 815.999 356.612 815.999 397.062V481.348Z",
    fill: "#F09F9C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.931732c2236c4e6e2fd58e515b75f53e.svg";
export { ForwardRef as ReactComponent };